/* 发布订阅标准事件名 - start */ 
const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change'
};
/* 发布订阅标准事件名 - end */ 


/* 全局发布订阅事件管理 - start */ 
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) { subscribers[eventName] = []; }
  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {return cb !== callback;});
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {callback(data);});
  }
}
/* 全局发布订阅事件管理 - end */ 



/* 元素焦点管理 - start */ 
const trapFocusHandlers = {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  
    if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
}
  
/* 元素焦点管理 - end */ 


/* 通用Fetch - start */
function fetchConfig(method = 'POST') {
    return {
        method,
        headers: { 
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json', 
            Accept: `application/json`,
            cr: pageInfo?.cr || 'US',
            lang: pageInfo?.lang || 'en'
        }
    };
} 

function formatFetchUrl(url = '') {
    let _url = '';
    switch (pageInfo?.env) {
        case 'prod':
            _url = 'https://api.myjackery.com';
            break;
        case 'uat':
            _url = 'https://api-uat.myjackery.com';
            break;
        case 'demo':
            _url = 'https://demo-api.myjackery.com';
            break;
        default:
            _url = 'https://api.myjackery.com';
            break;
    }
    return _url;
}
/* 通用Fetch - end */ 



/* Shopify common script - start */
typeof window.Shopify > "u" && (window.Shopify = {});
/* Shopify common script - end */ 


/* common utils - start */ 
function getUrlQueryParams(key = '') {
  if (typeof location === 'undefined') {
    console.error('getUrlQueryParams Error: location object is not available.');
    return key ? undefined : {};
  }
  const searchParams = new URLSearchParams(location.search);
  const res = {};
  for (const [k, v] of searchParams.entries()) {
    res[k] = v;
  }
  return key ? res[key] : res;
}

function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
      clearTimeout(timeout),
      timeout = setTimeout( () => func.apply(this, args), wait);
  }
}

function throttle(fn, delay) {
  let timer;
  return function () {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, arguments);
        timer = null;
      }, delay);
    }
  }
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function copyString (value, cb) {
  const textarea = document.createElement('textarea');
  textarea.readOnly = 'readonly';
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  textarea.value = value;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('Copy');
  document.body.removeChild(textarea);
  cb && cb();
}

function getAbsoluteTop(element) {
  if (!element) return 0;
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return rect.top + scrollTop;
}
/* common utils - end */ 



/* ga Function - start */ 
function handleGaEvents(doc = document) {
  const gaElts = doc.querySelectorAll("[data-ga-event]");
  if (gaElts.length === 0) return;
  [...gaElts].map((elt) => {
      try {
          const evtType = elt.getAttribute("data-ga-action")
          const evtName = elt.getAttribute("data-ga-event")
          if (!evtType) return
          if (!evtName) return

          function handleGA(evt) {
            evt.stopPropagation();

            if(!evt.isTrusted) return
              const target = $(this)[0]
              let url = '';
              if (target.getAttribute("data-href")) {
                  // evt.preventDefault();
                  url = target.getAttribute("data-href");
              }
              let params = {}
              const attributeNames = target.getAttributeNames();

              attributeNames.forEach(attribute => {
                  if(attribute.indexOf("data-ga-params-") === 0) {
                      const key = attribute.replace("data-ga-params-", "")
                      params[key] = target.getAttribute(attribute)
                  }
              });
                
              window.dataLayer.push({ event_parameters: null });
              window.dataLayer.push({
                  event: "ga4Event",
                  event_name: evtName,
                  event_parameters: {
                      current_page: window.location.href,
                      ...params
                  }
              });

              elt.setAttribute("ga-loaded", true)

              setTimeout(function() {
                  if (url) {
                      if(target.getAttribute("target") === "_blank") {
                          window.open(url, "_blank");
                      } else {
                          window.location.href = url
                      }
                  }
              }, 40)
          }

          if(elt.getAttribute("ga-loaded")) return
          elt.removeEventListener(evtType, handleGA)
          elt.addEventListener(evtType, handleGA)
      } catch (e) {
          console.log(
              "Something wrong happened when setting up event handling for ga4Events."
          );
      }
  });
}
/* ga Function - end */ 



// 各站点 storefrontAccessToken
const STOREFRONT_ACCESS_TOKEN = new Map([
  ['localhost', '08defaa91b45739dabbffc832d38a840'], // demo us 本地
  // ['localhost', '2601a17adc7213e7797a277bb896b491'], // demo us 本地，跳 checkout 会提示库存不足
  ['shop.sit-eu.jackery.com', '08defaa91b45739dabbffc832d38a840'], // demo us
  // ['shop.sit-eu.jackery.com', '2601a17adc7213e7797a277bb896b491'], // demo us，跳 checkout 会提示库存不足
  ['shop.sit-jp.jackery.jp', '0266aec2eb519d5248900b1ba51fe4b1'], // demo jp
  ['shop.uat-us.jackery.com', '093e86307a6b0efafd65021527b4c1f1'], // uat us
  ['www.jackery.com', 'e2a57b2ebbb0a5e04466f5d8567bca90'], // us
  ['de.jackery.com', 'ee55fef5baa5c56a40614cb839f6419d'], // de
  ['www.jackery.jp', 'a927af62fe55976f73b69231b91c88bb'], // jp
  ['uk.jackery.com', '7d8f22b6071a6819aec2a8a2d8b4ecbc'], // uk
  ['ca.jackery.com', '5ce809c34718f7b4b93eab5acc1725c1'], // ca
  ['au.jackery.com', 'ac20c26499e70e8ea84cf8a99034669c'], // au
  ['fr.jackery.com', 'bb81ff0958cf730357e5f60fedb1224f'], // fr
  ['eu.jackery.com', '652f4daa5b46fa2afd9cce57e7964d22'], // eu
])

/**
 * 创建独立购物车并跳转到结账页面，只需要开checkout的【只读】权限即可
 * @param {Array} items - 商品列表数组，每个商品包含 quantity, id, properties
 * @returns {Promise}
 */
function createCartAndCheckout (items) {
  if (!Array.isArray(items)) {
    return console.error('[createCartAndCheckout] Parameter validation failed: Expected an array')
  }

  // 获取当前站点的域名
  const hostname = window.location.hostname;
  // 从 Map 中查找 Token
  const storefrontAccessToken = STOREFRONT_ACCESS_TOKEN.get(hostname);

  return new Promise((resolve, reject) => {
    // 将 properties 转换为 GraphQL 格式
    const attributesToGraphQL = (properties) => {
      const result = Object.entries(properties).map(([key, value]) => ({ key, value }));
      return result
        .map((attr) => `{key: "${attr.key}", value: "${attr.value}"}`)
        .join(', ');
    };

    // 构建 GraphQL 的 lines 输入
    const lines = items
      .map(
        (item) => `{
          quantity: ${item.quantity},
          merchandiseId: "gid://shopify/ProductVariant/${item.id}",
          attributes: [${attributesToGraphQL(item.properties)}]
        }`
      )
      .join(',');

    // 发起 GraphQL 请求
    fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({
        query: `
          mutation {
            cartCreate(
              input: {
                lines: [${lines}]
              }
            ) {
              cart {
                checkoutUrl
              }
            }
          }
        `,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.errors) {
          console.error('GraphQL Errors:', data.errors);
          reject(new Error('GraphQL request failed'));
        } else {
          const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;
          resolve(checkoutUrl); // 返回结账 URL
        }
      })
      .catch((error) => {
        console.error('Error creating cart:', error);
        reject(error);
      });
  })
}

/* Gloal events - start */
function initSmoothScroll() {
  document.addEventListener("click", function(event) {
      if (event.target.matches("[data-anchor]")) {
          event.preventDefault();
          const href = event.target.getAttribute("href");
          if (!href || href === "#") return;
          const targetId = href.replace("#", "");
          const targetSection = document.getElementById(targetId);
          if (targetSection) {
              const headerHeight = parseFloat(getComputedStyle(document.querySelector("body")).getPropertyValue("--jky-header-h")) || 0;
              const targetPosition = getAbsoluteTop(targetSection) - headerHeight;
              window.scrollTo({
                  top: targetPosition,
                  behavior: "smooth"
              })
          }
      }
  })
}
document.addEventListener("DOMContentLoaded", initSmoothScroll)
/* Gloal events - end */
// 通用数据埋码
const gaPushDataLayer = (eventName = 'users_click', params) => {
  window.dataLayer.push({ "event_parameters": null });
  window.dataLayer.push({
    event: 'ga4Event',
    event_name: eventName,
    event_parameters: {
      'current_page': window.location.href,
      ...params
    }
  });
}
